import FrontpageSettingsForm from './FrontpageSettingsForm'
export default FrontpageSettingsForm
